// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"f0506915","236":"17a2d202","407":"2ac922fd","421":"83571726","925":"b41ba148","935":"afd00398"}[chunkId] + ".chunk.css";
};